"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = exports.removeData = exports.storeData = exports.getLocalStorage = exports.useStateWithLocalStorage = void 0;
const get_1 = __importDefault(require("lodash/get"));
const set_1 = __importDefault(require("lodash/set"));
const react_1 = require("react");
function useStateWithLocalStorage(localStorageKey, key) {
    const [value, setValue] = (0, react_1.useState)(localStorage.getItem(localStorageKey) || '{}');
    (0, react_1.useEffect)(() => {
        localStorage.setItem(localStorageKey, value);
    }, [localStorageKey, value]);
    const setData = (0, react_1.useCallback)((data, key = null) => {
        let castData = JSON.parse(value);
        if (key) {
            (0, set_1.default)(castData, key, data);
        }
        else {
            castData = { ...castData, ...data };
        }
        setValue(JSON.stringify(castData));
    }, [value]);
    return (0, react_1.useMemo)(() => {
        return [
            key ? (0, get_1.default)(JSON.parse(value), key, {}) : JSON.parse(value),
            setData,
        ];
    }, [key, setData, value]);
}
exports.useStateWithLocalStorage = useStateWithLocalStorage;
function getLocalStorage(localStorageKey, isJson = true) {
    const settings = localStorage.getItem(localStorageKey);
    return settings && isJson ? JSON.parse(settings) : settings;
}
exports.getLocalStorage = getLocalStorage;
function storeData(localStorageKey, value) {
    localStorage.setItem(localStorageKey, value);
}
exports.storeData = storeData;
function removeData(localStorageKey) {
    localStorage.removeItem(localStorageKey);
}
exports.removeData = removeData;
function getValue(object, keyPath, defaultValue = null) {
    return (0, get_1.default)(object, keyPath, defaultValue);
}
exports.getValue = getValue;
